import PropTypes from 'prop-types';
import React from 'react';
import { Typography } from '@sm/wds-react';

import PackageCta from '../PackageCta';
import { packageLabelToClassName, monthlyCostInDollars, getCoreCostFromSkus } from '~pricing/lib/helpers';

const TeamPackageHeader = ({ packageName, skuCosts, details }) => {
  const packageClassName = packageLabelToClassName(details);
  const coreSeatCost = getCoreCostFromSkus(skuCosts);
  const price = monthlyCostInDollars(coreSeatCost);

  return (
    <header className="sm-package__header" data-testid="TeamPackageHeader__Header">
      <Typography
        component="h1"
        variant="sectionTitle"
        className="sm-package__title"
        data-testid="TeamPackageHeader__HeaderText"
      >
        {details.displayName.toUpperCase()}
      </Typography>
      <Typography
        component="h2"
        variant="cardTitle"
        data-testid="TeamPackageHeader__Price"
        className="sm-package__cost"
      >
        <Typography component="span" variant="pageTitle" className="sm-package__cost-amount">
          {`$${price}`}
        </Typography>
        {' / user / month'}
      </Typography>
      <Typography component="h3" variant="body" className="sm-package__byline">
        Starting at 3 users, billed annually
      </Typography>
      <PackageCta packageName={packageName} packageClassName={packageClassName} />
    </header>
  );
};

TeamPackageHeader.propTypes = {
  packageName: PropTypes.string.isRequired,
  details: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  skuCosts: PropTypes.arrayOf(
    PropTypes.shape({
      skuType: PropTypes.string.isRequired,
      cost: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default TeamPackageHeader;
